import { Card, Col } from "reactstrap";
import SentContent from "./sent-content/SentContent";
import EmailHeader from "../email-header/EmailHeader";
import { EmailData } from "../types";

interface EmailRightSideProps {
  composeEmail: boolean;
  setComposeEmail: (value: boolean) => void;
  emailValidation: boolean;
  setEmailValidation: (value: boolean) => void;
  searchWord: string;
  setSearchWord: (value: string) => void;
  emails: EmailData[];
  handleAddEmail: (newEmail: {
    userEmail: string;
    subject: string;
    message: string;
  }) => void;
  emailOpen: string[];
  toggleEmailOpen: (id: string) => void;
}

const EmailRightSide: React.FC<EmailRightSideProps> = ({
  composeEmail,
  setComposeEmail,
  emailValidation,
  setEmailValidation,
  searchWord,
  setSearchWord,
  emails,
  handleAddEmail,
  emailOpen,
  toggleEmailOpen,
}) => {
  return (
    <Col xxl="12">
      <div className="email-right-aside">
        <Card className="email-body email-list">
          <EmailHeader
            searchWord={searchWord}
            setSearchWord={setSearchWord}
            setComposeEmail={setComposeEmail}
          />
          <SentContent
            emails={emails}
            emailOpen={emailOpen}
            toggleEmailOpen={toggleEmailOpen}
            searchWord={searchWord}
          />
        </Card>
      </div>
    </Col>
  );
};

export default EmailRightSide;
